// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2Tsr4{height:24px;height:2.4rem;width:24px;width:2.4rem}", ""]);
// Exports
exports.locals = {
	"box__icon": "_2Tsr4"
};
module.exports = exports;
